import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {SummaryFieldType} from '../../../../shared/model/common/summary-field/summary-field-type';
import {StringUtils} from '../../../../shared/utils/string.utils';
import * as moment from 'moment-timezone';
import {MomentAdapter} from '../../../../shared/utils/moment.utils';
import {CoerceBoolean} from '../../../../shared/utils/coercion.utils';
import {ThemePalette} from '@angular/material/core';

@Component({
    selector: 'app-summary-field',
    styleUrls: ['./summary-field.component.scss'],
    template: `
        <div [style]="labelWithValue || !label || (!hasContent && !defaultValue) ? 'display: none' : ''">
            <strong>{{label}}</strong>
        </div>
        <div class="appSummaryField" [style]="!hasContent && !defaultValue ? 'display: none' : ''" [style.background]="backgroundColor">
            <div style="display: flex; align-items: center;">
                <ng-content select="[icon]"></ng-content>
                <i-tabler style="margin: auto;" *ngIf="iconName" [style.color]="textColor"
                          [name]="iconName"
                          class="icon-14 d-flex m-r-4"
                ></i-tabler>
                <div  [style]="!value && !defaultValue ? 'display: none' : ''" [style.color]="textColor">
                    <span *ngIf="textOverflow" class="appSummaryField_content" #valueSummary [text-overflow]="['',maxLength, '']"></span>
                    <span *ngIf="!textOverflow" class="appSummaryField_content" #valueSummary></span>
                </div>

                <div #content>
                    <ng-container *ngIf="label && labelWithValue && !value"><ion-text [color]="color">{{label}} : </ion-text></ng-container>
                    <ng-content></ng-content>
                </div>
                <ng-content select="[buttons]"></ng-content>
                
            </div>
        </div>
    `
})
export class SummaryFieldComponent implements OnInit, OnChanges, AfterViewInit {

    @Input() label: string;
    @Input() value: SummaryFieldType;
    @Input() unit: string;
    @Input() iconName: string;
    @Input()
    @CoerceBoolean()
    labelWithValue = true;
    @Input()
    @CoerceBoolean()
    textOverflow = false;

    @Input() removeHtmlTags = false;
    @Input() htmlContent = true;
    @Input() color: ThemePalette;
    @Input() dateFormat = 'DD/MM/YYYY';
    @Input() maxLength: number;
    @Input() backgroundColor = '#EFECEC';
    @Input() textColor: string;
    @Input() defaultValue: string;

    @ViewChild('valueSummary') valueSummaryElement: ElementRef;
    @ViewChild('content', {read: ElementRef, static: true}) content: ElementRef;

    hasContent = false;

    ngOnInit(): void {
        this.hasContent = !!this.value || !!this.content.nativeElement.innerHTML || !!this.defaultValue;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['unit'] || changes['value'] || changes['htmlContent'] || changes['defaultValue']) {
            if (this.valueSummaryElement) {
                this.adaptFormattedValue();
            }
        }
        this.hasContent = !!this.value || !!this.content.nativeElement.innerHTML || !!this.defaultValue;
    }
    formattedValue(): string {
        if (!this.value || this.value === '') {
            return this.defaultValueOrEmpty;
        }
        let formattedValue;
        if (this.value instanceof Array) {
            if (this.value.length === 0) {
                formattedValue = this.defaultValueOrEmpty;
            } else {
                formattedValue = StringUtils.joinLovValues(this.value);
            }
        } else if (typeof this.value === 'boolean') {
            formattedValue = this.value ? 'Oui' : 'Non';
        } else if (this.value instanceof moment) {
            formattedValue = this.formatDate((this.value as moment.Moment));
        } else {
            formattedValue = this.value;
        }
        if (this.label && this.labelWithValue) {
            formattedValue = this.label + ' : ' + formattedValue;
        }

        return this.unit ? formattedValue + ' ' + this.unit : formattedValue;
    }

    get defaultValueOrEmpty() {
        return this.defaultValue ? this.defaultValue : '';
    }

    private formatDate(date: moment.Moment) {
        return MomentAdapter.of(date).format(this.dateFormat);
    }

    private adaptFormattedValue() {
        const formattedValue: string | number = this.formattedValue();
        if (this.valueSummaryElement) {
            if (this.htmlContent) {
                this.valueSummaryElement.nativeElement.innerHTML = this.removeHtmlTags ? StringUtils.removeHtml(formattedValue) : formattedValue;
            } else {
                this.valueSummaryElement.nativeElement.innerText = formattedValue;
            }
        }
    }

    ngAfterViewInit(): void {
        this.adaptFormattedValue();
    }
}
